import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { API_URI, SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
// import Carousel from 'src/components/carousels';

const Header = dynamic(import('src/components/layouts/header'), { ssr: true });
const Footer = dynamic(import('src/components/layouts/footer'), { ssr: false });
const Carousel = dynamic(() => import('src/components/carousels'), {
  ssr: false,
  loading: () => <>loading....</>
});

const Layout = ({ children, ads, sessionSevId }) => {
  const [navData, setNavData] = useState(null);
  const [dataSets, setDataSets] = useState([]);

  const router = useRouter();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [navRes, dataSetsAll] = await Promise.all([fetch(`${API_URI}/api/v1.0/navigations/menu-nav`).then(r => r.json()), GET('/api/datasets')]);

        if (!isEmpty(dataSetsAll)) {
          setDataSets(find(dataSetsAll, { topic: 'ADS' }) || []);
        }

        if (!('msg' in navRes)) {
          setNavData(navRes);
        }
      } catch (err) {
        console.error('Layout fetch error:', err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      let deferredPrompt;
      const addBtn = document.querySelector('.add-button');
      const addBtnClose = document.querySelector('.add-button-close');

      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        deferredPrompt = e;
        if (addBtn) addBtn.style.display = 'block';

        addBtn?.addEventListener('click', () => {
          addBtn.style.display = 'none';
          deferredPrompt?.prompt();
          deferredPrompt?.userChoice?.then(() => {
            deferredPrompt = null;
          });
        });
        addBtnClose?.addEventListener('click', () => {
          addBtnClose.style.display = 'none';
        });
      });
    }, 3000); // หน่วง 3s

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!isEmpty(dataSets.dataSet) && (
        <AdsDefault className='container ads-default-billbord ' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
          <>
            <Carousel>
              {dataSets.dataSet?.map((itemSet, index) => (
                <div key={index} className='carousel-center justify-center'>
                  <a
                    target='_blank'
                    tabIndex='-1'
                    rel='noreferrer noopener nofollow'
                    href={itemSet.key}
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_INDEX,
                        router: router?.pathname,
                        section: 'imagecover',
                        data: {
                          title: itemSet?.key,
                          heading: 'imagecover',
                          carousel: index + 1
                        }
                      })
                    }
                  >
                    <img src={itemSet.value} alt={itemSet.key} width='100%' height='100%' />
                  </a>
                </div>
              ))}
            </Carousel>
          </>
        </AdsDefault>
      )}

      <Header data={navData} sessionSevId={sessionSevId} />
      {children}
      <Footer data={navData} ads={ads} />
    </>
  );
};

const AdsDefault = styled.div`
  margin: 15px auto;
  position: relative;
  min-height: 250px;
  @media (max-width: 768px) {
    min-height: 191px;
  }
  @media (max-width: 480px) {
    min-height: 90px;
    padding: 0;
  }
  &.ads-default-billbord {
    width: auto;
    height: auto;
    max-width: 100%;
    overflow: hidden;
    img {
      width: auto !important;
      height: auto;
      max-width: 100%;
    }
  }
  .carousel-center {
    display: flex !important;
  }
  p {
    position: absolute;
    bottom: 0;
    font-size: 18px;
    font-weight: 600;
    color: #00ff57;
    border: 2px solid #00ff57;
    padding: 5px;
    left: 50%;
    background: black;
    transform: translate(-50%, 0);
  }
`;

export default Layout;
